import { Box, Typography } from "@mui/material";

export default function Disclaimer() {
  return (

    <Box
        sx={{
          mt: { xs: '24px', md: '27.9px' },
          p: { xs: '16px' },
          borderRadius: '20px',
          background: '#D9D9D91A',
        }}
      >
        <Typography
          sx={{
            fontWeight: '600',
            fontSize: { xs: '14px', md: '16px' },
            lineHeight: '34px',
            letterSpacing: '-0.02em',
            color: '#793AFF',
          }}
        >
          Disclaimer
        </Typography>

        <Typography
          mt="4px"
          sx={{
            fontWeight: '400',
            fontSize: { xs: '11px', md: '12px' },
            lineHeight: '20px',
            letterSpacing: '-0.02em ',
            color: '#333333',
          }}
        >
          We Recommend That You Familiarize Yourself With The Following Please Read Everything In This Disclaimer
          Carefully. If You Are Unsure About Your Future Actions, We Recommend That You Seek Legal, Financial, Tax, Or
          Other Professional Advice.
        </Typography>
      </Box>
  )
}